/** Resolves bundled public assets correctly at a domain root or a deployed subdirectory. */
export function assetPath(path: string) {
  return `${import.meta.env.BASE_URL}${path.replace(/^\/+/, '')}`;
}
